<template>
    <body :class="{unselectable:resizingIndex!=null}">
        <div class="half-screen" :style="{ width: widths[0] }">
            <div class="resize-handle" @mousedown="startResize(0)"></div>

            <div class="tablecontainer full">
                <table>
                    <thead v-if="emails_data!=null">
                        <tr>
                            <th colspan="2">
                                <div class="emailtable" style="margin-bottom:10px">
                                    <p>Emails</p>
                                    <input style="margin-right:0px;" v-model="term" @keydown.enter="searchEmails()"/>
                                    <button v-on:click="searchEmails()"><font-awesome-icon icon="search" /></button>
                                </div>
                                <div class="emailtable" style="width:100%;">
                                    <input type="checkbox" style="width:15px; margin-right:5px; " v-model="nocontacts" v-on:click="nextTickSearch()"/>
                                    <p class="emailtabletext">No Contacts</p>
                                    <input type="checkbox" style="width:15px; margin-right:5px;" v-model="nojoborders" v-on:click="nextTickSearch()"/>
                                    <p class="emailtabletext">No Job Orders</p>
                                    <p class="emailtabletext">From</p>
                                    <input
                                    id="fromdate"
                                    type="date"
                                    v-model="fromdate"
                                    style="height:30px; width:150px;"/>
                                    <p class="emailtabletext">To</p>
                                    <input
                                    id="todate"
                                    type="date"
                                    v-model="todate"
                                    style="height:30px; width:150px;"/>
                                </div>
                            </th>
                        </tr>
                    </thead>
                    <thead v-else><tr><th class="table-header" colspan="3">Table Empty</th></tr></thead>
                    <tbody v-if="emails_data!=null">
                        <tr v-for="(data, col) in emails_data" v-on:click="getEmail(col)" :class="{selected:emailId==data[0]}" style="border: 1px solid #ddd;">
                            <td style="border:none;">
                                <div style="margin:0px;">
                                    <p style="margin:0px; word-break:break-all; height:20px; overflow:hidden; font-size:18px;">{{ data[4] }}</p>
                                    <p style="margin:0px; word-break:break-all; height:20px; overflow:hidden; font-weight:bold; color:#106EBE; font-size:14px;">{{ data[6] }}: {{ data[2] }}</p>
                                    <p style="margin-bottom:5px; word-break:break-all; height:15px; overflow:hidden; font-size:10px;">{{ data[5] }}</p>
                                </div>
                            </td>
                            <td style="width:0px; border:none; vertical-align:top;">
                                <div style="display:flex; flex-direction:column;">
                                    <div style="height:20px; padding-right:10px;">
                                        <font-awesome-icon v-if="data[8]==0" style="width:15px; height:15px; color:red; float:right;" icon="circle" />
                                        <font-awesome-icon v-if="data[9]!=0" style="width:15px; height:15px; color:gray; float:right;" icon="paperclip" />
                                    </div>
                                    <p style="margin:0px 10px 0px 10px; white-space:nowrap; font-weight:bold; color:#106EBE; font-size:14px;">{{ data[1].substr(0,16) }}</p>
                                </div>
                            </td>
                        </tr>
                        <tr>
                            <td colspan="2"><button v-on:click="loadMore()">Load More</button></td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>

        <div class="half-screen" :style="{ width: widths[1] }">
            <div class="resize-handle" @mousedown="startResize(1)"></div>

            <div class="tablecontainer full" style="padding-right:8px;">
                <div v-if="resizingIndex!=null" class="iframeCover"></div>
                <div v-if="selectIndex!=null" style="overflow-y:scroll; height:100%;">
                    <div class="emailheader">{{emails_data[selectIndex][4]}}</div>
                    <div class="emailheader">Date: {{emails_data[selectIndex][1]}}</div>
                    <div class="emailheader">From: {{emails_data[selectIndex][2]}}</div>
                    <div class="emailheader">To: {{emails_data[selectIndex][3]}}</div>
                    <div class="emailheader">Acc: {{emails_data[selectIndex][6]}}</div>
                    <div class="emailheader" style="max-height:100px; overflow-y:scroll;">CC: {{emails_data[selectIndex][7]}}</div>
                    <hr style="width:100%;"/>
                    <iframe style="width:100%; flex: 1;" v-if="emailHtml" ref="emailFrame"></iframe>
                    <div v-else>Loading Email</div>
                </div>
                <div v-else>No Email Selected</div>
            </div>
        </div>

        <div class="half-screen" :style="{ width: widths[2] }">
            <div class="tablecontainer half" style="overflow-x:scroll">
                <table>
                    <thead v-if="emailcontacts_data!=null && emailcontacts_data.length>0">
                        <tr>
                            <th v-bind:colspan="emailcontacts_data[0].length">Email Contacts <input v-model="contactterm" @keydown.enter="searchEmailContacts()"></input><button v-on:click="searchEmailContacts()"><font-awesome-icon icon="search" /></button></th>
                        </tr>
                        <tr>
                            <th style="width:30px;"/>
                            <th v-for="(name,i) in emailcontacts_names" v-if="i>0">{{ name }}</th>
                        </tr>
                    </thead>
                    <thead v-else><tr><th class="table-header">Table Empty</th></tr></thead>
                    <tbody v-if="emailcontacts_data!=null">
                        <tr v-for="(data, col) in emailcontacts_data" v-on:click="">
                            <td>
                                <input type="checkbox" style="width:30px;" v-model="emailcontacts_checks[col]" v-on:change="setContact(col)"></input>
                            </td>
                            <td v-for="(val,i) in data" v-if="i>0">
                                <p>{{ val }}</p>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>

            <div class="tablecontainer half" style="overflow-x:scroll">
                <table>
                    <thead v-if="emailjoborders_data!=null && emailjoborders_data.length>0">
                        <tr>
                            <th v-bind:colspan="emailjoborders_data[0].length">Email Job Orders <input v-model="joborderterm" @keydown.enter="searchEmailJoborders()"></input><button v-on:click="searchEmailJoborders()"><font-awesome-icon icon="search" /></button></th>
                        </tr>
                        <tr>
                            <th style="width:30px;"/>
                            <th v-for="(name,i) in emailjoborders_names" v-if="i>0">{{ name }}</th>
                        </tr>
                    </thead>
                    <thead v-else><tr><th class="table-header">Table Empty</th></tr></thead>
                    <tbody v-if="emailjoborders_data!=null">
                        <tr v-for="(data, col) in emailjoborders_data" v-on:click="">
                            <td>
                                <input type="checkbox" style="width:30px;" v-model="emailjoborders_checks[col]" v-on:change="setJoborder(col)"></input>
                            </td>
                            <td v-for="(val,i) in data" v-if="i>0">
                                <p v-if="i==1">11-{{ ("00000"+val).substr(-5) }}</p>
                                <p v-else>{{ val }}</p>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>

    </body>
</template>

<script>
import {PAGES} from './../../../constants.js'
import api from '@/api'
import { nextTick } from 'vue';
export default {

/*
SELECT a.emailid,a.date,a.fromadr,a.toadr,a.subject_en, \
REPLACE(REPLACE(a.msgbodytxt_en,'&nbsp;',''),'\xC2\xA0','') message, \
group_concat(b.accountname order by accountname asc) account, \
ifnull(a.ccadr,''), a.processed
*/

    data() {
        return {
			pageid1:PAGES.EMAILS_PAGE,
			pageid2:PAGES.EMAILS_CONTACTS_PAGE,
			pageid3:PAGES.EMAILS_JOBORDERS_PAGE,

            emails_data: [/*["emailid","date","from","to","subject","message","account","cc","0","attachment"]*/],
            data_offset: 0,

            emailcontacts_names: [],
            emailcontacts_data: [],
            emailcontacts_checks: [],
            emailjoborders_names: [],
            emailjoborders_data: [],
            emailjoborders_checks: [],

            emailHtml: null,
            emailId: null,
            selectIndex: null,

            term:"",
            nocontacts:false,
            nojoborders:false,
            fromdate:"",
            todate:"",
            contactterm:"",
            joborderterm:"",

            widths: ['33.33%', '33.33%', '33.33%'],
            resizingIndex: null,
        };
    },
	async created () {
        this.searchEmails();
        this.setWidths();
        this.detectKeys();
    },
	methods:{
        detectKeys() {
            nextTick(() => {
                let self = this
                document.addEventListener('keydown', function(event) {
                    const key = event.key; // "ArrowRight", "ArrowLeft", "ArrowUp", or "ArrowDown"
                    if(key=="ArrowUp") {
                        if(self.selectIndex==null) self.selectIndex = 0;
                        self.getEmail(self.selectIndex-1);
                    }
                    if(key=="ArrowDown") {
                        if(self.selectIndex==null) self.selectIndex = 0;
                        self.getEmail(self.selectIndex+1);
                    }
                });
            });
        },
        async nextTickSearch() {
            nextTick(() => {
                this.searchEmails();
            });
        },
        async searchEmails() {
            api.postData(
                {
                    type:"search",
                    data:{
                        pageid:this.pageid1,
                        term:this.term,
                        offset:0,
                        nojoborders:this.nojoborders,
                        nocontacts:this.nocontacts,
                        fromdate:this.fromdate,
                        todate:this.todate,
                    }
                }
            ).then((res) => {
				if(res.data.data!=null && res.data.data.column_names!=null){
					this.emails_data = res.data.data.column_data;
                    this.data_offset = 0;
                    for(let i = 0;i<this.emails_data.length;i++) {
                        for(let j = 0;j<this.emails_data[i].length;j++) {
                            this.emails_data[i][j] = api.decodeMIMEString(this.emails_data[i][j]);
                        }
                    }
				}
            });
        },
        async loadMore() {
            this.data_offset+=1;

            api.postData(
                {
                    type:"search",
                    data:{
                        pageid:this.pageid1,
                        term:this.term,
                        offset:this.data_offset,
                        nojoborders:this.nojoborders,
                        nocontacts:this.nocontacts,
                        fromdate:this.fromdate,
                        todate:this.todate,
                    }
                }
            ).then((res) => {
                if(res.data.data!=null && res.data.data.column_names!=null){
                    for(let i = 0;i<res.data.data.column_data.length;i++) {
                        if(res.data.data.column_data[i].length==0) continue;
                        for(let j = 0;j<res.data.data.column_data[i].length;j++) {
                            res.data.data.column_data[i][j] = api.decodeMIMEString(res.data.data.column_data[i][j]);
                        }
                        this.emails_data.push(res.data.data.column_data[i]);
                    }
                }
            });
        },
        searchEmailContacts() {
            this.emailcontacts_names = [];
            this.emailcontacts_data = [];
            this.emailcontacts_checks = [];

            api.postData(
                {
                    type:"search",
                    data:{
                        pageid:this.pageid2,
                        term:this.emailId,
                        search:this.contactterm,
                    }
                }
            ).then((res) => {
				if(res.data.data!=null && res.data.data.column_names!=null){
                    this.emailcontacts_names = res.data.data.column_names;
					this.emailcontacts_data = res.data.data.column_data;

                    for(let i = 0;i<this.emailcontacts_data.length;i++) {
                        if(this.emailcontacts_data[i][0]>0) {
                            this.emailcontacts_checks[i] = true;
                        }else {
                            this.emailcontacts_checks[i] = false;
                        }
                    }
				}
            });
        },
        setContact(col) {
            let contactId = this.emailcontacts_data[col][1];
            let val = this.emailcontacts_checks[col];

            api.postData(
                {
                    type:"insert",
                    data:{
                        pageid:this.pageid2,
                        emailid:this.emailId,
                        contactid:contactId,
                        val:val,
                    }
                }
            ).then((res) => {

            });
        },
        searchEmailJoborders() {
            this.emailjoborders_names = [];
            this.emailjoborders_data = [];
            this.emailjoborders_checks = [];

            api.postData(
                {
                    type:"search",
                    data:{
                        pageid:this.pageid3,
                        term:this.emailId,
                        search:this.joborderterm,
                    }
                }
            ).then((res) => {
                if(res.data.data!=null && res.data.data.column_names!=null){
                    this.emailjoborders_names = res.data.data.column_names;
                    this.emailjoborders_data = res.data.data.column_data;

                    for(let i = 0;i<this.emailjoborders_data.length;i++) {
                        if(this.emailjoborders_data[i][0]>0) {
                            this.emailjoborders_checks[i] = true;
                        }else {
                            this.emailjoborders_checks[i] = false;
                        }
                    }
                }
            });
        },
        setJoborder(col) {
            let joborderId = this.emailjoborders_data[col][1];
            let val = this.emailjoborders_checks[col];

            api.postData(
                {
                    type:"insert",
                    data:{
                        pageid:this.pageid3,
                        emailid:this.emailId,
                        joborderid:joborderId,
                        val:val,
                    }
                }
            ).then((res) => {

            });
        },
        getEmail(col) {
            if(col<0 || col>=this.emails_data.length) return;
            this.selectIndex = col;
            let emailId = this.emails_data[col][0];
            this.emailId = emailId;
            this.getEmailHtml(emailId);
            this.searchEmailContacts();
            this.searchEmailJoborders();
        },
        getEmailHtml(emailId) {
            this.emailHtml = null;
            api.getData("api/email/"+emailId).then((res) => {
                if(res.data!=null) {
                    this.emailHtml = res.data;

                    nextTick(() => {
                        const frame = this.$refs.emailFrame;
                        if (frame) {
                            const frameDoc = frame.contentDocument || frame.contentWindow.document;
                            frameDoc.open();
                            frameDoc.write(this.emailHtml);
                            frameDoc.close();
                        }
                    });
                }
            });
        },

        setWidths() {
            var getWidths = JSON.parse(api.getCookie("widths_"+this.pageid1))
            if(getWidths.length!=this.widths.length){
                api.eraseCookie("widths_"+this.pageid1);
            }else {
                this.widths = getWidths;
            }
        },
        startResize(index) {
            this.resizingIndex = index;
            document.addEventListener('mousemove', this.handleResize);
            document.addEventListener('mouseup', this.stopResize);
        },
        handleResize(event) {
            if (this.resizingIndex !== null) {
                const containerWidth = this.$el.clientWidth;
                const rect = this.$el.children[this.resizingIndex].getBoundingClientRect();
                const newWidth = ((event.clientX - rect.left) / containerWidth) * 100;
                const newWidths = [...this.widths];

                // Ensure we don't set negative or zero width
                newWidths[this.resizingIndex] = `${Math.max(newWidth, 0)}%`;
                let difference = parseFloat(newWidths[this.resizingIndex])-parseFloat(this.widths[this.resizingIndex]);
                newWidths[this.resizingIndex+1] = `${Math.max(parseFloat(this.widths[this.resizingIndex+1])-difference,0)}%`;

                const totalWidth = newWidths.reduce((acc, w) => acc + parseFloat(w), 0);
                if (totalWidth > 100) {
                    newWidths[this.resizingIndex] = `${parseFloat(newWidths[this.resizingIndex]) - (totalWidth - 100)}%`;
                }

                this.widths = newWidths;
            }
        },
        stopResize() {
            this.resizingIndex = null;
            document.removeEventListener('mousemove', this.handleResize);
            document.removeEventListener('mouseup', this.stopResize);

            var self = this;
            setTimeout(function(){
                document.cookie="widths_"+self.pageid1+"="+JSON.stringify(self.widths)+";";
            }, 10);
        },
    },
    watch:{
		fromdate: function (val, oldValue) {
            this.searchEmails();
        },
        todate: function (val, oldValue) {
            this.searchEmails();
        },
    }
}
</script>

<style scoped>
    template, body {
        height: calc(100vh - 52px);
        margin: 0;
        display: flex;
    }

    .half-screen {
        height: 100%;
        overflow-y: auto;
        padding: 5px;
        border: 1px solid gray;
        position: relative;
        box-sizing: border-box;
    }
    .resize-handle {
        position: absolute;
        width: 5px;
        height: 100%;
        background-color: none;
        right: 0;
        top: 0;
        cursor: ew-resize;
    }
    .unselectable {
        -moz-user-select: none;
        -khtml-user-select: none;
        -webkit-user-select: none;
        user-select: none;
    }
    .iframeCover {
        content:"";
        position:absolute;
        left:0;
        right:0;
        top:0;
        bottom:0;
    }

    table {
        width: 100%;
        border-collapse: collapse;
    }
    th, td {
        padding: 4px;
        text-align: left;
        border: 1px solid #bbb;
    }

    .tablecontainer {
        overflow-y: auto;
        margin-bottom:10px;
        background-color: white;
        overflow-x:hidden;
    }
    .full {
        height:calc(100% - 10px);
    }
    .half {
        height:calc(50% - 10px);
    }
    .emailheader {
        font-size: 18px;
    }
    .selected {
        background-color: #ddd;
    }
    .emailtable {
        display:inline-flex;
        height:30px;
    }
    .emailtable > * {
        margin-right: 15px;
    }
    .emailtabletext {
        font-size: 0.85rem;
        font-weight: normal;
        margin:0px;
        margin-top:4px;
        margin-right:8px;
    }
    iframe {
        width:100%;
        height:100%;
        border: none; /* Remove border if not needed */
    }
</style>



// WEBPACK FOOTER //
// src/components/file/Emails.vue